<div class="catalogPage">
  <ng-container #container></ng-container>

  <app-catalog-form></app-catalog-form>
</div>
